var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger small-button d-flex align-items-center justify-content-center fw-bold p-3",attrs:{"type":"button"}},[_vm._v("\n  -\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }